module.exports = __webpack_public_path__ + "media/images/favicon-b51c886b08186b9c6a10359ab6b84692.ico";